export default __webpack_public_path__ + "static/media/data.58957fea.jpg";